export const apiMall = "http://www.cdaoxuan.top/";
export const javaApi = "https://mp.cdaoxuan.top:29922/";
export const appName = "澳选跨境免税";
export const isOverseas = false;
export const unit = "元";
export const miniProgramUrl = "https://mp.cdaoxuan.top:29922/scan";

export const footCopyrightInfo = "Copyright © 2026-2026 成都澳选供应链科技有限公司";
export const footRecordInformation = "蜀ICP备2025176496号-2";
export const footGongAnBeianHref = "";
export const footGongAnBeianInformation = "";
export const appId = 'wxda7a8ee590603b9f';
export const isH5 = false; //是否H5
export const h5Url = ''
export const scanToOrderMsg = '微信扫一扫打开小程序下单'
export const isTouchScreen = false; //是否触摸屏(是则移除注册，登录，立即购买按钮)